/* eslint-disable */
import React from 'react';

import './default-cell.css';

type Props = {
  value?: string;
  className?: string;
  containerClassName?: string;
};

function DefaultTableBodyCell({ value, className, containerClassName }: Props) {
  return (
    <div className={`default-cell-container ${containerClassName}`}>
      <p
        className={`default-cell-txt ${
          value === 'Yes' ? 'font-success' : value === 'No' ? 'font-error' : ''
        } ${className}`}
        title={value}
      >
        {value}
      </p>
    </div>
  );
}

export default DefaultTableBodyCell;
